import { useMemo } from 'react'
import styles from './style.module.scss'
import PropTypes from 'prop-types'
function BowlerOvers({ playerData }) {
  const getClassNames = useMemo(() => {
    return (ball) => {
      if (ball === '6' || ball === '4') {
        return 'bg-success text-white'
      } else if (ball === 'w') {
        return 'redSix text-white'
      }
      return ''
    }
  }, [])

  return (
    <div className='d-flex justify-content-between align-items-center'>
      <div className={styles.bowlerOversWrapper}>
        <div className={styles.bowlerOversName}>
          <span>{playerData?.sOver || '-' } Ov</span>
          <span>{playerData?.nRuns || '0'} Runs</span>
        </div>
        <div className={styles.bowlerOversBall}>
          {playerData?.aEvents?.map((ball, index) => (
            <span key={index} className={getClassNames(ball)}>
              {ball || '-'}
            </span>
          ))}
        </div>
      </div>
    </div>
  )
}

BowlerOvers.propTypes = {
  playerData: PropTypes.object
}

export default BowlerOvers
